import * as $ from 'jquery';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ShippingAvailabilityLandingFilterVM } from '../../../../models/ShippingAvailability/ShippingAvailabilityLandingFilterVM';
import { ShippingAvailabilityService } from '../../../../services/seed/reports/shipping-availability-report.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { ReportType } from '../../../../models/report-type.model';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BranchPlantVM } from '../../../../models/ShippingAvailability/BranchPlantVM';
import { Router } from '@angular/router';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-shipping-availability',
  templateUrl: './shipping-availability.component.html',
  styleUrls: ['./shipping-availability.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class ShippingAvailabilityComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('shippingAvailabilityTable', { read: MatSort }) shippingAvailabilitySort: MatSort;
  @ViewChild('shippingAvailabilityPaginator', { read: MatPaginator }) shippingAvailabilityPaginator: MatPaginator;

  private readonly originalDisplayedColumns: Array<ColumnDescription> = [
    { columnfield: 'detail', headertxt: 'detail' },
    { columnfield: 'parentAccountNumber', headertxt: 'Parent Account' },
    { columnfield: 'parentAccountName', headertxt: 'Parent Account Name' },
    { columnfield: 'accountNumber', headertxt: 'Account' },
    { columnfield: 'accountName', headertxt: 'Account Name' },
    { columnfield: 'city', headertxt: 'City' },
    { columnfield: 'state', headertxt: 'State' },
    { columnfield: 'productLine', headertxt: 'Product Line' },
    { columnfield: 'itemNumber', headertxt: 'Item Number' },
    { columnfield: 'productDescription', headertxt: 'Product Description' },
    { columnfield: 'packageSize', headertxt: 'Package Size' },
    { columnfield: 'seedSize', headertxt: 'Seed Size' },
    { columnfield: 'treatment', headertxt: 'Treatment' },
    //{ columnfield: 'eaUnits', headertxt: 'EA Units' },
    //{ columnfield: 'eaModifiableUnits', headertxt: 'EA Modifiable Units' },
    { columnfield: 'dealerOrderTotalQuantity', headertxt: 'Dealer Order Total Quantity' },
    { columnfield: 'previouslyShippedAndScheduledQuantity', headertxt: 'Previously Shipped + Scheduled Quantity' },
    { columnfield: 'dealerOrderOpenQuantity', headertxt: 'Dealer Order Open Quantity' },
    { columnfield: 'availableToShipQuantity', headertxt: 'Available To Ship Quantity' }];

  public currentFilter = new UserReportFilter();

  displayedColumns: string[] = this.originalDisplayedColumns.map(x => x.columnfield);

  companyCodeChangeSubscription: Subscription;
  effectiveConfigData: any;
  filterOptionsData: Array<FilterOption>;
  filter: ShippingAvailabilityLandingFilterVM = new ShippingAvailabilityLandingFilterVM();
  headerCompany: string;
  isApprovalAccess = false;
  isEvolveAccountRestriction = false;
  masterConstants = MasterConstants;
  readOnlyAccess = false;
  shippingAvailabilityColumns: string[] = [];
  shippingAvailabilityDataSource: MatTableDataSource<any>;
  shippingAvailabilityResultList: any = [];
  branchPlantResultList: any = [];
  shippingAvailabilityList: any = [];
  subscription = new Subscription();
  tabNode: boolean;
  userMenuAccessList: any;
  validateEvolveData: any;
  selectedBranchPlantList: Array<BranchPlantVM> = [];
  isReleaseOrderEnable: boolean = false;
  hasReleaseOrderAccess: boolean = false;
  constructor(
    public excelService: ExcelService,
    private loaderService: LoaderService,
    private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private matDialog: MatDialog,
    private shippingAvailabilityService: ShippingAvailabilityService,
    private toastrService: ToastrService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.headerCompany = MasterConstants.US_COMPANYCODE;
    this.setFilterAndGridColumn();
    this.setDefaultFilter();
    this.setDropDownValues();

    this.subscription.add(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          this.currentFilter = filter;

          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          this.displayedColumns = [];
          this.displayedColumns.push('detail');
          filters.displayedColumns.forEach(x => {
            this.displayedColumns.push(x.columnfield);
          });

          
          this.filterOptionsData = filters.filterOption;
          this.setDropDownValues();
          this.filter = filters.filter;

          //this.getGridData();
        }
        else {
          if (filter && filter.filterDescription === this.currentFilter.filterDescription || !filter)
            this.currentFilter = new UserReportFilter();
        }
      }));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (evolveAccessData) {
        this.userMenuAccessList = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany).userMenuAccessList;
        this.hasReleaseOrderAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.FULFILLMENT_PRODUCT_AVAILABILITY_REPORT, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);
      }
    }
  }

  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Parent Account Number', key: 'parentAccountNumber', controlType: ControlType.Text, sequenceNumber: 0 },
      { label: 'Parent Account Name', key: 'parentAccountName', controlType: ControlType.Text, sequenceNumber: 1 },
      { label: 'Account Number', key: 'accountNumber', controlType: ControlType.Text, sequenceNumber: 2 },
      { label: 'Account Name', key: 'accountName', controlType: ControlType.Text, sequenceNumber: 3 },
      { label: 'Product Line', key: 'productLine', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', sequenceNumber: 4 },
      { label: 'Product Name', key: 'productName', controlType: ControlType.Text, sequenceNumber: 5 },
      { label: 'Package Size', key: 'packageSize', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', sequenceNumber: 6 },
      { label: 'Seed Size', key: 'seedSize', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', sequenceNumber: 7 },
      { label: 'Treatment', key: 'treatment', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', sequenceNumber: 8 },
      { label: 'Item Number', key: 'itemNumber', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value', sequenceNumber: 9 },
    ];
  }

  setDefaultFilter() {
    this.filter = {
      accountName: null,
      accountNumber: null,
      parentAccountNumber: null,
      itemNumber: null,
      packageSize: null,
      productLine: null,
      productName: null,
      seedSize: null,
      treatment: null,
      state: null
    };
  }

  setDropDownValues() {
    if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'itemNumber').controlData = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
    }

    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.filterOptionsData.find(x => x.key === 'packageSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'productLine').controlData = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'seedSize').controlData = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'treatment').controlData = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }

  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 250;
      $('.activeshippingAvailability').css('max-height', templateHeight + 'px');
    }, 100);
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  ngOnDestroy() {
    this.userReportFilterSliderService.resetFilter();

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.shippingAvailabilityService.getAvailabilityReportData(this.filter).subscribe((result: any) => {
      this.shippingAvailabilityResultList = result.shippingAvailabilityReportList;
      this.setGridData(result.shippingAvailabilityReportList);
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  setGridData(result: any[]) {
    this.shippingAvailabilityList = result;

    this.shippingAvailabilityDataSource = new MatTableDataSource(this.shippingAvailabilityList);
    this.shippingAvailabilityDataSource.paginator = this.shippingAvailabilityPaginator;
    this.shippingAvailabilityDataSource.paginator.firstPage();
    this.shippingAvailabilityDataSource.sort = this.shippingAvailabilitySort;
  }

  filterSearchClick(event) {
    this.filter = event;
    this.getGridData();
  }

  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData();
  }

  // Show details
  showDetails(event: UIEvent, element,): void {
    element.selected = !element.selected;
  }

  emailData() {
    this.tabNode = this.tabNode ? false : true;
    let accountEmail = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        accountEmail = data.resultData[0].emailId;
      }
    }

    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { email: accountEmail, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' }
    });

    emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          EmailIds: emailIds,
          ShippingAvailabilityReportList: this.shippingAvailabilityList,
          BranchPlantDetails: this.branchPlantResultList
        };
        this.loaderService.setLoaderStatus(true);
        this.shippingAvailabilityService.emailProductAvailabilityList(data).subscribe(result => {
          if (result) { this.toastrService.success('Email sent'); }
          this.loaderService.setLoaderStatus(false);
        }, error => {
          this.loaderService.setLoaderStatus(false);
          LolLoggerService.info(error);
        });
      }
      this.tabNode = false;
    });
  }

  //Select filter
  public selectFilter(filters: UserFilterColumnDisplayed) {
    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.ShippingAvailabilityReport, 0, this.originalDisplayedColumns.filter(x => x.columnfield !== 'detail'), newFilter);
  }

  //Add filter
  public addFilter(filters: UserFilterColumnDisplayed) {
    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.ShippingAvailabilityReport, 1, this.originalDisplayedColumns.filter(x => x.columnfield !== 'detail'), newFilter);
  }

  //Edit Filter
  public editFilter(filters: UserFilterColumnDisplayed) {
    filters.displayedColumns = this.displayedColumns.filter(z => z !== "detail").map(x => this.originalDisplayedColumns.find(y => y.columnfield === x));

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 1, this.originalDisplayedColumns.filter(x => x.columnfield !== 'detail'), this.currentFilter);
  }

  public save(filters: UserFilterColumnDisplayed): void {
    filters.displayedColumns = this.displayedColumns.filter(z => z !== "detail").map(x => this.originalDisplayedColumns.find(y => y.columnfield === x));

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
    else {
      this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
  }

  public export() {
    const data = {
      EmailIds: '',
      ShippingAvailabilityReportList: this.shippingAvailabilityList,
      BranchPlantDetails: this.branchPlantResultList,
      DisplayedColumns: this.displayedColumns.filter(z => z !== "detail").map(x => this.originalDisplayedColumns.find(y => y.columnfield === x).headertxt)
    };

    this.loaderService.setLoaderStatus(true);
    this.shippingAvailabilityService.exportProductAvailabilityList(data).subscribe(result => {
      if (result) { this.shippingAvailabilityService.base64toFile(result.base64, result.mimeType, result.fileName); }
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.info(error);
    });
  }

  selectBPNumber(element, branch, event) {
    let selectedBP = this.selectedBranchPlantList.filter(f => f.accountNumber == element.accountNumber
      && f.productLine == element.productLineId && f.branchPlant == branch.bpNumber && f.isBulk == element.isBulk);

    if (branch.isSelected && this.selectedBranchPlantList.length > 0 && selectedBP.length <= 0) {
      this.toastrService.warning('Please select same Branch Plant / Product Line / Account / Bulk Or Packaged to release orders');
      branch.isSelected = false;
      event.checked = false;
      event.source._checked = false;
    }

    if (branch.isSelected && event.checked) {
      branch.isSelected = true;
      this.selectedBranchPlantList.push({
        accountNumber: element.accountNumber,
        productLine: element.productLineId,
        branchPlant: branch.bpNumber,
        itemNumber: branch.itemNumber,
        isBulk: element.isBulk
      });
    } else {
      branch.isSelected = false;
      this.selectedBranchPlantList = this.selectedBranchPlantList.filter(f => !(f.accountNumber == element.accountNumber
        && f.productLine == element.productLineId && f.branchPlant == branch.bpNumber && f.isBulk == element.isBulk && f.itemNumber == branch.itemNumber));
    }
    this.isReleaseOrderEnable = this.hasReleaseOrderAccess && this.selectedBranchPlantList.length > 0;
  }

  releaseOrder() {
    if (this.hasReleaseOrderAccess && this.selectedBranchPlantList.length > 0) {
      this.shippingAvailabilityService.setSelectedBranchPlantList(this.selectedBranchPlantList);
      this.router.navigate([`reports/shipping-availability/release-order`]);
    }
  }
}
